import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Breadcrumbs } from "@/components/PageHeader";
import { DutchieEmbed } from "@/components/DutchieEmbed";
import { BUSINESS, CATEGORIES, DUTCHIE, PAGES, shopCategoryUrl } from "@/lib/site";
import { track } from "@/lib/analytics";

const CRUMBS = [{ name: "Home", path: "/" }, { name: "Shop", path: "/shop-all" }];
const activeCat = (search) => new URLSearchParams(search).get("dtche[category]") || "";

const Chips = ({ current, onPick }) => (
  <nav aria-label="Shop by category" className="-mx-4 overflow-x-auto px-4 sm:mx-0 sm:px-0">
    <ul className="flex w-max gap-2 pb-1">
      {[{ slug: "", name: "All products" }, ...CATEGORIES].map((c) => (
        <li key={c.slug || "all"}>
          <Link
            to={c.slug ? shopCategoryUrl(c.slug) : "/shop-all"}
            onClick={() => onPick(c.slug)}
            aria-current={current === c.slug ? "page" : undefined}
            data-testid={`shop-chip-${c.slug || "all"}`}
            className={`chip ${current === c.slug ? "chip-active" : ""}`}
          >
            {c.name}
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);

export default function Shop() {
  const { search } = useLocation();
  const [cat, setCat] = useState(() => activeCat(search));
  const [mount, setMount] = useState(0);
  const pick = (slug) => {
    track("category_click", { category: slug || "all", location: "shop_chips" });
    setCat(slug);
    setMount((m) => m + 1);
  };

  return (
    <>
      <Seo {...PAGES.shop} path="/shop-all" crumbs={CRUMBS} />
      <section className="bg-brand-paper pt-10" data-testid="shop-page">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <Breadcrumbs items={CRUMBS} />
          <div className="mt-5 grid gap-4 lg:grid-cols-12 lg:items-end">
            <h1 className="font-display text-4xl font-black leading-[0.95] tracking-tighter sm:text-5xl lg:col-span-7">
              Shop the <span className="rounded bg-brand-lime px-2">Live Menu</span>
            </h1>
            <p className="text-sm leading-relaxed text-neutral-600 lg:col-span-5">
              Real-time prices and stock. Order ahead, then come upstairs at {BUSINESS.street} (next to Chicken + Whiskey) with your 21+ ID and medical registration.{" "}
              <Link to="/faq" className="font-bold text-brand-red" data-testid="shop-faq-link">Ordering FAQ</Link>
              {" · "}<Link to="/medical-card" className="font-bold text-brand-red" data-testid="shop-medical-card-link">Need a medical card? Self-certify</Link>
              {" · "}<Link to="/special-deals" className="font-bold text-brand-red" data-testid="shop-deals-link">Today's deals</Link>
            </p>
          </div>
          <div className="mt-6"><Chips current={cat} onPick={pick} /></div>
        </div>
        <div className="mx-auto mt-6 max-w-7xl sm:px-6">
          <div className="dutchie-menu bg-white sm:rounded-2xl sm:border sm:border-neutral-200" onClickCapture={() => track("menu_interaction", { location: "shop" })}>
            <DutchieEmbed key={mount} scriptId={DUTCHIE.menuId} src={DUTCHIE.menuSrc} minHeight={900} testId="dutchie-menu" label="the live menu" />
          </div>
        </div>
        <div className="h-16" />
      </section>
    </>
  );
}
